/**
 * 二次封装 `sa.track(eventName, properties, callback)` 接口
 */
const sa = window.sa;


export default function track(eventName, properties, callback) {
  track.exec(eventName, properties, callback);
}

track.middlewares = [];

track.use = function use(middleware) {
  track.middlewares.push(middleware);
};

track.exec = function exec(eventName, properties, callback) {
  // 注意：params 是引用型
  const params = { eventName, properties, callback };
  track.middlewares.reduce((params, middleware) => {
    middleware(params);
    return params;
  }, params);

  sa.track(params.eventName, params.properties, params.callback);
};
